import React, { useEffect, useState } from "react";
import {
  Input,
  Select,
  Space,
  Form,
  Button,
  notification,
  message,
  DatePicker,
} from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import bookingRequest from "../BookingRequest";
import bookingStatusRequest from "../BookingStatusRequest";
import bookingTypeRequest from "../BookingTypeRequest";
import userRequest from "../../UserManagement/UserRequest";
import carRequest from "../../Other Master/CarRequest";
import { Option } from "antd/es/mentions";
import dayjs from "dayjs";

export const UpdateBooking = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams(); // Get the id from the URL params
  const [bookingStatusList, setBookingStatusList] = useState([]);
  const [bookingTypeList, setBookingTypeList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [driverList, setDriverList] = useState([]);
  const [carList, setCarList] = useState([]);
  const [bookingData, setBookingData] = useState(null); // Store the fetched booking data

  const fetchBookingStatusList = () => {
    setLoading(true);
    bookingStatusRequest
      .bookingStatusList()
      .then((response) => {
        const rawData = response?.data?.data || [];
        console.log(rawData);
        setBookingStatusList(rawData);
      })
      .catch((error) => {
        message.error("Failed to fetch booking status list");
        console.log("error", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchBookingTypeList = () => {
    setLoading(true);
    bookingTypeRequest
      .bookingTypeList()
      .then((response) => {
        const rawData = response?.data?.data || [];
        console.log(rawData);
        setBookingTypeList(rawData);
      })
      .catch((error) => {
        message.error("Failed to fetch booking type list");
        console.log("error", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchVendorList = () => {
    setLoading(true);
    userRequest
      .vendorList()
      .then((response) => {
        const rawData = response?.data?.data || [];
        setVendorList(rawData);
      })
      .catch((error) => {
        message.error("Failed to fetch vendor list");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchDriverList = (vendorId) => {
    setLoading(true);
    userRequest
      .driverList(vendorId)
      .then((response) => {
        const rawData = response?.data?.data || [];
        setDriverList(rawData);
      })
      .catch((error) => {
        message.error("Failed to fetch driver list");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchCarList = (ownerId) => {
    setLoading(true);
    carRequest
      .carList(ownerId)
      .then((response) => {
        const rawData = response?.data?.data || [];
        setCarList(rawData);
      })
      .catch((error) => {
        message.error("Failed to fetch car list");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchBookingData = () => {
    setLoading(true);
    bookingRequest
      .getBookingById(id) // Assuming you have a method to get the booking by ID
      .then((response) => {
        const data = response?.data?.data || {};
        console.log(data);
        setBookingData(data); // Save fetched data to bookingData state
        form.setFieldsValue({
          ...data, // Populate the form fields with fetched data
          startDate: data.startDate ? dayjs(data.startDate) : null,
          endDate: data.endDate ? dayjs(data.endDate) : null,
          bookingStatusId: data.bookingStatusId || bookingStatusList[0]?.id, // Set default bookingStatusId if not provided
          carSupplierId: data.carSupplierId,
        });
        fetchDriverList(data.carSupplierId ?? 0);
        fetchCarList(data.carSupplierId ?? 0);
      })
      .catch((error) => {
        message.error("Failed to fetch booking data");
        console.log("error", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onFinish = (values) => {
    console.log(values);
    setLoading(true); // Add id to the updated data
    // Ensure the date fields are correctly formatted
    const allFormData = {
      ...values,
      startDate: values.startDate
        ? values.startDate.format("YYYY-MM-DD")
        : null,
      endDate: values.endDate ? values.endDate.format("YYYY-MM-DD") : null,
    };
    bookingRequest
      .updateBooking(id, allFormData) // Assuming you have an API method for updating bookings
      .then((res) => {
        if (res.status === 200) {
          notification.success({
            message: "Booking updated successfully",
          });
          navigate(-1, { state: { refresh: true } }); // Navigate to the booking list page (or previous page)
        } else {
          notification.error({
            message: "Something went wrong",
          });
          setLoading(false);
        }
      })
      .catch((e) => {
        setLoading(false);
        notification.error({
          message: "Failed to update booking",
        });
        console.error("API Error:", e);
      });
  };

  const handleChange = (value, name) => {
    console.log(`selected ${value}`);
    if (name === "carSupplierId") {
      fetchDriverList(value);
      fetchCarList(value);
    }
  };

  const handleSubmit = () => {
    form.submit(); // Trigger form validation and submission
  };

  useEffect(() => {
    fetchBookingStatusList(); // Fetch the booking status list on initial render
    fetchBookingTypeList();
    fetchVendorList();
    if (id) {
      fetchBookingData(); // Fetch the booking data when editing a booking
    }
  }, [id]);

  return (
    <>
      <section>
        <div className="Create-Category">
          <Form.Item className="text-center submit-btn">
            <Space>
              <Button
                className="f-sub-btn btn-width"
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                <ArrowLeftOutlined />
              </Button>
            </Space>
          </Form.Item>
          <h3>Update Booking</h3>

          {/* Add Ant Design Form component and pass the form instance */}
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={{
              bookingStatusId:
                bookingStatusList.length > 0
                  ? bookingStatusList[0].id
                  : undefined, // Default value for bookingStatusId
            }}
          >
            {/* First Row */}
            <div className="subscription">
              <Form.Item
                name="indecabId"
                label="Indecab Booking Id"
                className="subscription-plan"
              >
                <Input size="large" placeholder="Enter IndecabId" />
              </Form.Item>

              <Form.Item
                name="passengerName"
                label="Passenger Name"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the Passenger Name",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter Passenger Name" />
              </Form.Item>

              <Form.Item
                name="passengerPhone"
                label="Passenger Phone"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the Passenger Phone!",
                  },
                  {
                    pattern: /^[0-9]{10}$/,
                    message: "Phone No must be exactly 10 digits!",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter Passenger Phone" />
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                name="fromCity"
                label="From City"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the From City",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter From City" />
              </Form.Item>

              <Form.Item
                name="toCity"
                label="To City"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the To City",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter To City" />
              </Form.Item>
            </div>
            <div className="subscription">
              <Form.Item
                name="vehicleGroup"
                label="Vehicle Group"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the Vehicle Group",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter Vehicle Group" />
              </Form.Item>
              <Form.Item
                name="bookingTypeId"
                label="Duty Type"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please select the duty type!",
                  },
                ]}
              >
                <Select
                  placeholder="Select The Duty Type"
                  style={{ marginTop: "0.5rem", width: "99%" }}
                  onChange={(value) => handleChange(value, "bookingTypeId")}
                >
                  {bookingTypeList?.length > 0 &&
                    bookingTypeList.map((item, idx) => (
                      <Option
                        key={idx}
                        className="text-capitalize"
                        value={item?.id}
                      >
                        {item?.typeName}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </div>
            <div className="subscription">
              <Form.Item
                name="startDate"
                label="Start Date"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please select the start date" },
                ]}
              >
                <DatePicker
                  placeholder="Select Start Date"
                  style={{ width: "99%" }}
                />
              </Form.Item>
              <Form.Item
                name="endDate"
                label="End Date"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please select the end date" },
                ]}
              >
                <DatePicker
                  placeholder="Select End Date"
                  style={{ width: "99%" }}
                />
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                name="reportingTime"
                label="Reporting Time"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please select the reporting time!",
                  },
                ]}
              >
                <Input
                  type="time"
                  placeholder="Select Reporting Time"
                  style={{ width: "99%" }}
                />
              </Form.Item>

              <Form.Item
                name="estDropTime"
                label="Est. Drop Time"
                className="subscription-plan"
              >
                <Input
                  type="time"
                  placeholder="Select Est Drop Time"
                  style={{ width: "99%" }}
                />
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                name="bookingPrice"
                label="Booking Price"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the booking Price",
                  },
                ]}
              >
                <Input
                  type="number"
                  size="large"
                  placeholder="Enter Booking Price"
                />
              </Form.Item>

              <Form.Item
                name="supplierPrice"
                label="Supplier Price"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the Supplier Price",
                  },
                ]}
              >
                <Input
                  type="number"
                  size="large"
                  placeholder="Enter Supplier Price"
                />
              </Form.Item>
            </div>
            <div className="subscription">
              <Form.Item
                name="dutyCustomerId"
                label="Duty Customer"
                className="subscription-plan"
              >
                <Select
                  placeholder="Select The Duty Customer"
                  style={{ marginTop: "0.5rem", width: "99%" }}
                  onChange={(value) => handleChange(value, "dutyCustomerId")}
                >
                  {vendorList?.length > 0 &&
                    vendorList.map((item, idx) => (
                      <Option key={idx} value={item?.id}>
                        {item?.fullName}
                      </Option>
                    ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="carSupplierId"
                label="Car Supplier"
                className="subscription-plan"
              >
                <Select
                  placeholder="Select The Car Supplier"
                  style={{ marginTop: "0.5rem", width: "99%" }}
                  onChange={(value) => handleChange(value, "carSupplierId")}
                >
                  {vendorList?.length > 0 &&
                    vendorList.map((item, idx) => (
                      <Option key={idx} value={item?.id}>
                        {item?.fullName}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </div>
            <div className="subscription">
              <Form.Item
                name="driverId"
                label="Driver"
                className="subscription-plan"
              >
                <Select
                  placeholder="Select The Driver"
                  style={{ marginTop: "0.5rem", width: "99%" }}
                  onChange={(value) => handleChange(value, "driverId")}
                >
                  {driverList?.length > 0 &&
                    driverList.map((item, idx) => (
                      <Option key={idx} value={item?.id}>
                        {item?.fullName}
                      </Option>
                    ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="vehicleId"
                label="Vehicle"
                className="subscription-plan"
              >
                <Select
                  placeholder="Select The Vehicle"
                  style={{ marginTop: "0.5rem", width: "99%" }}
                  onChange={(value) => handleChange(value, "vehicleId")}
                >
                  {carList?.length > 0 &&
                    carList.map((item, idx) => (
                      <Option key={idx} value={item?.id}>
                        {item?.model}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </div>
            <div className="subscription">
              <Form.Item
                name="tajwayCabCommision"
                label="Tajway Cab Commision"
                className="subscription-plan"
              >
                <Input
                  type="number"
                  size="large"
                  placeholder="Enter Car Supplier Commision"
                />
              </Form.Item>
              <Form.Item
                name="bookingStatusId"
                label="Booking Status"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please select the booking status!",
                  },
                ]}
              >
                <Select
                  placeholder="Select The Booking Status"
                  style={{ marginTop: "0.5rem", width: "99%" }}
                  onChange={(value) => handleChange(value, "bookingStatusId")}
                >
                  {bookingStatusList?.length > 0 &&
                    bookingStatusList.map((item, idx) => (
                      <Option
                        key={idx}
                        className="text-capitalize"
                        value={item?.id}
                      >
                        {item?.statusName}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </div>
            <div className="subscription">
              <Form.Item
                name="bookingAdvance"
                label="Booking Advance"
                className="subscription-plan"
              >
                <Input
                  type="number"
                  size="large"
                  placeholder="Enter Booking Advance"
                />
              </Form.Item>

              <Form.Item
                name="paymentMode"
                label="Payment Mode"
                className="subscription-plan"
              >
                <Select
                  placeholder="Select Payment Mode"
                  style={{ marginTop: "0.5rem", width: "99%" }}
                  onChange={(value) => handleChange(value, "bookingTypeId")}
                >
                  <Option value="cash">Cash</Option>
                  <Option value="credit">Credit</Option>
                </Select>
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                name="appRemarks"
                label="App Remarks"
                className="subscription-plan"
              >
                <Input.TextArea size="large" placeholder="Enter App Remarks" />
              </Form.Item>

              <Form.Item
                name="bookingRemarks"
                label="Booking Remarks"
                className="subscription-plan"
              >
                <Input.TextArea
                  size="large"
                  placeholder="Enter Booking Remarks"
                />
              </Form.Item>
            </div>

            <div className="bottom-button">
              <div style={{ padding: "10px" }}>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Save
                  <span>
                    <AiOutlineRight />
                  </span>
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </section>
    </>
  );
};
